import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { editPublicacion } from '../../../../actions/publicacionesActions';
import PropTypes from 'prop-types';

const Entrega = ({ inCreate }) => {
    const publicacion = useSelector(state => state.publicaciones.publicacion);
    const userType = useSelector(state => state.general.userType);
    const dispatch = useDispatch();

    useEffect(() => {
        if (inCreate && !publicacion.zonasEnvioGratis) {
            dispatch(editPublicacion({
                ...publicacion,
                zonasEnvioGratis: {
                    amba: true,
                    interior: true,
                    patagonia: true
                }
            }));
        }
    }, [inCreate, publicacion, dispatch]);

    const handleChange = (event) => {
        const { name, checked } = event.target;
        const updated = { ...publicacion };
        const zonas = ['amba', 'interior', 'patagonia'];

        if (zonas.includes(name)) {
            updated.zonasEnvioGratis = publicacion.zonasEnvioGratis ?
                { ...publicacion.zonasEnvioGratis, [name]: checked } : { [name]: checked };
        } else {
            switch (name) {
                case 'envioPropio':
                case 'envioGratis':
                    updated[name] = checked;
                    break;
                case 'envioDomicilio':
                    updated.envioDomicilio = checked;
                    if (checked) updated.retiroSucursalMegatone = false;
                    break;
                case 'retiroSucursalMegatone':
                    updated.retiroSucursalMegatone = checked;
                    if (checked) updated.envioDomicilio = false;
                    break;
                default:
                    break;
            }
        }

        dispatch(editPublicacion(updated));
    };

    return (
        <div className="tab-pane p-20 active" id="home2" role="tabpanel">
            <div className="row form-group d-flex flex-wrap gap-3">

                {/* Tipo de Entrega */}
                <div className="col-md-5 p-3 border rounded bg-light">
                    <h5 className="fw-bold">Tipo de Entrega</h5>
                    <div className="d-flex flex-column">
                        <div className="row ms-1">
                            <div className="col-12 my-1">
                                <input
                                    id="envioDomicilio"
                                    type="checkbox"
                                    className="me-2"
                                    checked
                                    disabled
                                />
                                <label htmlFor="envioDomicilio">Envío a domicilio</label>
                            </div>
                            <div className="col-12 my-1">
                                <input
                                    type="checkbox"
                                    id="sucursalMegatone"
                                    className="me-2"
                                    disabled
                                />
                                <label htmlFor="sucursalMegatone">Retiro sucursal de Megatone</label>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Costo de Envío */}
                <div className="col-md-6 p-3 border rounded bg-light">
                    <h5 className="fw-bold">Costo de Envío</h5>

                    {/* Envío gratis y A cargo del comprador */}
                    {!publicacion?.seller?.envioPropio && (
                        <div className="d-flex flex-column mb-3">
                            <div className="form-check mb-2">
                                <input
                                    id="envioGratis"
                                    name="envioGratis"
                                    type="checkbox"
                                    className="me-2"
                                    checked={publicacion.envioGratis}
                                    onChange={handleChange}
                                    disabled={publicacion?.seller?.envioPropio}
                                />
                                <label className="form-check-label" htmlFor="envioGratis">Envío gratis</label>
                            </div>

                            {/* Zonas */}
                            {!inCreate && (
                                <div className="ms-3 d-flex flex-column">
                                    <div className="form-check mb-2">
                                        <input
                                            id="envioAmba"
                                            name="amba"
                                            type="checkbox"
                                            className="me-2"
                                            checked={!!publicacion.zonasEnvioGratis?.amba}
                                            disabled={!publicacion.envioGratis || publicacion?.seller?.envioPropio}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor="envioAmba">Amba</label>
                                    </div>
                                    <div className="form-check mb-2">
                                        <input
                                            id="envioInterior"
                                            name="interior"
                                            type="checkbox"
                                            className="me-2"
                                            checked={!!publicacion.zonasEnvioGratis?.interior}
                                            disabled={!publicacion.envioGratis || publicacion?.seller?.envioPropio}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor="envioInterior">Interior</label>
                                    </div>
                                    <div className="form-check mb-2">
                                        <input
                                            id="envioPatagonia"
                                            name="patagonia"
                                            type="checkbox"
                                            className="me-2"
                                            checked={!!publicacion.zonasEnvioGratis?.patagonia}
                                            disabled={!publicacion.envioGratis || publicacion?.seller?.envioPropio}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor="envioPatagonia">Patagonia</label>
                                    </div>
                                </div>
                            )}

                            <div className="form-check">
                                <input
                                    id="aCargoComprador"
                                    name="envioGratis"
                                    type="checkbox"
                                    className="me-2"
                                    checked={!publicacion.envioGratis}
                                    onChange={(e) => {
                                        const fakeEvent = {
                                            target: { name: 'envioGratis', checked: !e.target.checked }
                                        };
                                        handleChange(fakeEvent);
                                    }}
                                />
                                <label className="form-check-label" htmlFor="aCargoComprador">A cargo del comprador</label>
                            </div>
                        </div>
                    )}

                    {/* Logística Propia */}
                    {publicacion?.seller?.envioPropio && (
                        <div className="form-check">
                            <input
                                name="envioGratis"
                                type="checkbox"
                                className="me-2"
                                onChange={handleChange}
                                disabled={!userType.isAdminMod && !userType.isCategory}
                                checked={publicacion.envioGratis}
                            />
                            <label className="form-check-label" htmlFor="logisticaPropia">Envío Gratis</label>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
Entrega.propTypes = {
    inCreate: PropTypes.bool
}

export default Entrega;
